///// <reference types="@types/googlemaps" />


import { Injectable, EventEmitter } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { BKSFilter } from '../common/types';
import * as moment from 'moment';

@Injectable()
export class SettingsService {
  private _windowStart: number = -12;
  private _windowEnd: number = 12;
  private _windowScrollStep: number = 10;
  private _windowScrollInterval: number = 10;
  private _inactivityInMinutes: number = 40;
  private _showNavbar: boolean = true;

  public toggleSound$: EventEmitter<string>;
  public toggleShowAllFlights$: EventEmitter<string>;
  public toggleShowPlannedFlights$: EventEmitter<string>;
  public toggleShowFinishedEvents$: EventEmitter<string>;
  public toggleShowAllDrivers$: EventEmitter<string>;
  public zoomChanged$: EventEmitter<number>;
  public toggleShowLandside$: EventEmitter<string>;
  public toggleShowNavbar$: EventEmitter<boolean>;

  private readonly currentAirport: string = "ARN";
  public getCurrentAirport(): string {
    return this.currentAirport;
  }

  private readonly DefaultLocale = 'sv-SE';
  public getCurrentLocale(): string {
    return this.DefaultLocale as string;
  }

  readonly settingsName = "BKSFilter";

  settings: BKSFilter;

  constructor(private cookieService: CookieService) {
    this.toggleSound$ = new EventEmitter();
    this.toggleShowAllFlights$ = new EventEmitter();
    this.toggleShowPlannedFlights$ = new EventEmitter();
    this.toggleShowFinishedEvents$ = new EventEmitter();
    this.toggleShowAllDrivers$ = new EventEmitter();
    this.toggleShowLandside$ = new EventEmitter();
    this.zoomChanged$ = new EventEmitter();
    this.toggleShowNavbar$ = new EventEmitter();

    this.loadSettings();

  }

  loadSettings() {
    var data = this.cookieService.get(this.settingsName);
    if (data) {
      this.settings = JSON.parse(data);
    }
    else {
      this.settings = new BKSFilter();
    }
  }

  get inactivityInMinutes(): number {
    return this._inactivityInMinutes;
  }

  get windowStartOffset() : number {
    return this._windowStart;
  }

  get windowEndOffset(): number {
    return this._windowEnd;
  }

  get windowStart(): Date {

    var currentTime = moment(new Date());
    currentTime.set({ minute: 0, second: 0, millisecond: 0 })
    currentTime = currentTime.subtract(Math.abs(this._windowStart), "hours");

    return currentTime.toDate();

  };

  get windowEnd(): Date {

    var currentTime = moment(new Date());
    //currentTime.set({ minute: 0, second: 0, millisecond: 0 })
    currentTime.set({ second: 0, millisecond: 0 })
    currentTime = currentTime.add(Math.abs(this._windowEnd), "hours");

    return currentTime.toDate();

  };

  get windowLength(): number {

    var currentTime = moment(new Date());
    currentTime.set({ minute: 0, second: 0, millisecond: 0 })
    currentTime = currentTime.add(Math.abs(this._windowEnd), "hours");

    return Math.abs(this._windowStart) + Math.abs(this._windowEnd);

  };

  get windowScrollStep(): number {
    return this._windowScrollStep;

  };

  get windowScrollInterval(): number {
    return this._windowScrollInterval * 60 * 1000;

  };

  get sound(): boolean { return this.settings ? this.settings.sound : false };
  get showAllFlights(): boolean { return this.settings ? this.settings.showAllFlights : false; };
  get showPlannedFlights(): boolean { return this.settings ? this.settings.showPlannedFlights : false };
  get showAllDrivers(): boolean { return this.settings ? this.settings.showAllDrivers : false };
  get showFinishedEvents(): boolean { return this.settings ? this.settings.showFinishedEvents : false };
  get showLandside(): boolean { return this.settings ? this.settings.showLandside : false };
  get mapZoom(): number { return this.settings ? this.settings.zoom : 0 };
  //get darkMap(): boolean { return this.settings ? this.settings.darkMap : false };
  get mapCenter(): google.maps.LatLng { return this.settings ? this.settings.mapCenter : null };

  saveSettings() {
    this.cookieService.set(this.settingsName, JSON.stringify(this.settings));
  }

  toggleSound() {
    if (this.settings) {
      this.settings.sound = !this.settings.sound;
      this.saveSettings();
      this.toggleSound$.emit("");
    }
  }

  toggleShowLandside() {
    if (this.settings) {
      this.settings.showLandside = !this.settings.showLandside;
      this.saveSettings();
      this.toggleShowLandside$.emit("");
    }
  }

  toggleShowAllFlights() {
    if (this.settings) {
      this.settings.showAllFlights = !this.settings.showAllFlights;
      this.saveSettings();
      this.toggleShowAllFlights$.emit("");
    }
  }

  toggleShowPlannedFlights() {
    if (this.settings) {
      this.settings.showPlannedFlights = !this.settings.showPlannedFlights;
      this.saveSettings();
      this.toggleShowPlannedFlights$.emit("");
    }
  }
  toggleShowNavbar() {
    this._showNavbar = !this._showNavbar;
    this.toggleShowNavbar$.emit(this._showNavbar);
  }

  toggleShowFinishedEvents() {
    if (this.settings) {
      this.settings.showFinishedEvents = !this.settings.showFinishedEvents;
      this.saveSettings();
      this.toggleShowFinishedEvents$.emit("");
    }
  }

  toggleShowAllDrivers() {
    if (this.settings) {
      this.settings.showAllDrivers = !this.settings.showAllDrivers;
      this.saveSettings();
      this.toggleShowAllDrivers$.emit("");
    }
  }
}
